import i18n from 'i18n-js';
import * as Yup from 'yup';
import { formatAmount } from 'utils';
import { MAX_AMOUNT } from 'constants';

const initialValues = (creditType, clone = false) => ({
  // Fixed values
  ...(creditType
    ? {}
    : {
        active: true,
        status: 'ACTIVE',
        auto: false,
        manual: true,
        default_quantity: 1,
        pricing_type: 'FIXEDAMOUNT',
      }),
  // tax_rate_default: creditType?.tax_rate_default || 0,
  // taxing_choice: creditType?.taxing_choice || 'DEFAULT',
  // User defined fields
  name: clone ? '' : creditType?.name || '',
  default_unit_price: formatAmount(creditType?.default_unit_price) || 0,
  description:
    clone && creditType?.description
      ? `Copy of ${creditType?.description}`
      : creditType?.description || '',
});

// Schema validation is only used for user defined fields
const formSchema = () =>
  Yup.object().shape({
    name: Yup.string().required(i18n.t('common.required_field')),
    default_unit_price: Yup.number()
      .min(
        1,
        i18n.t('common.custom_min_value', {
          min_value: new Intl.NumberFormat().format(1),
        })
      )
      .max(
        MAX_AMOUNT,
        i18n.t('common.max_value', {
          max_value: new Intl.NumberFormat().format(MAX_AMOUNT),
        })
      )
      .typeError(i18n.t('common.type_error'))
      .required(i18n.t('common.required_field')),
    description: Yup.string().nullable(),
  });

export { initialValues, formSchema };
